import { render, staticRenderFns } from "./patient-address.vue?vue&type=template&id=f3934030&lang=pug&"
import script from "./patient-address.vue?vue&type=script&lang=ts&"
export * from "./patient-address.vue?vue&type=script&lang=ts&"
import style0 from "./patient-address.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports